let categoryList: CategoryListType[] = []

interface CategoryListType {
    id: number,
    name: string
}

categoryList = [
    {id: 23, name: '我要变美'},
    {id: 25, name: '个人成长'},
    {id: 20, name: '婚姻情感'},
    {id: 21, name: '亲子教育'},
    {id: 27, name: '赚钱理财'},
    {id: 24, name: '享受生活'}
]

export default categoryList



// WEBPACK FOOTER //
// ./src/services/categoryIdList.ts